// ============================================
// OFFICEFORGED — Formula Bridge
// Detects {CardName.Cell} patterns in text and
// resolves them to live values from the card engine
// ============================================

import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const formulaBridgeKey = new PluginKey('formulaBridge');

const REF_PATTERN = /\{([^}]+)\}/g;

export function createFormulaBridgePlugin(cardEngine) {
  return new Plugin({
    key: formulaBridgeKey,
    state: {
      init(_, state) {
        return buildDecorations(state, cardEngine);
      },
      apply(tr, oldDecorations, oldState, newState) {
        if (tr.docChanged || tr.getMeta('cardUpdate')) {
          return buildDecorations(newState, cardEngine);
        }
        return oldDecorations.map(tr.mapping, tr.doc);
      }
    },
    props: {
      decorations(state) {
        return this.getState(state);
      }
    }
  });
}

function buildDecorations(state, cardEngine) {
  const decorations = [];

  state.doc.descendants((node, pos) => {
    if (!node.isText) return;

    const text = node.text;
    let match;
    REF_PATTERN.lastIndex = 0;

    while ((match = REF_PATTERN.exec(text)) !== null) {
      const from = pos + match.index;
      const to = from + match[0].length;
      const refString = match[0];

      const result = cardEngine.resolveReference(refString);

      decorations.push(
        Decoration.inline(from, to, {
          class: result.resolved ? 'card-ref' : 'card-ref unresolved',
          'data-ref': refString,
          title: refString + (result.resolved ? ` = ${result.value}` : ' (unresolved)')
        })
      );
    }
  });

  return DecorationSet.create(state.doc, decorations);
}

// Utility: trigger decoration refresh when cards change
export function refreshFormulas(view) {
  const tr = view.state.tr.setMeta('cardUpdate', true);
  view.dispatch(tr);
}
